import { allCases } from '../typescriptHelpers';

export enum RunwayUserAction {
    UAAddRemoveEditIntegration = 'AddRemoveEditIntegration',
    UATriggerIntegrationRefresh = 'TriggerIntegrationRefresh',
    UAUpdateAppSettings = 'UpdateAppSettings',
    UAEditAutomations = 'EditAutomations',
    UACreateDeleteApp = 'CreateDeleteApp',
    UACreateSkipDeleteCompleteReleases = 'CreateDeleteRelease',
    UACreateHotfix = 'CreateHotfix',
    UAUpdateScheduleCadence = 'UpdateScheduleCadence',
    UAUpdateReleaseTargetDates = 'UpdateReleaseTargetDates',
    UACreateBranchPromoteCode = 'CreateBranchPromoteCode',
    UABumpVersion = 'BumpVersion',
    UATagCommit = 'TagCommit',
    UAApproveScreenshotsMetadata = 'ApproveScreenshotsMetadata',
    UAPromoteBetaBuildToTestingTrack = 'PromoteBetaBuildToTestingTrack',
    UAApproveBetaTesting = 'ApproveBetaTesting',
    UAUpdateRegressionStatus = 'UpdateRegressionStatus',
    UASetResumeActiveRCBuild = 'SetResumeActiveRCBuild',
    UATriggerCIWorkflow = 'TriggerCIWorkflow',
    UAUpdateAppStoreSelectedBuild = 'UpdateAppStoreSelectedBuild',
    UASubmitAppUpdate = 'SubmitAppUpdate',
    UADevRejectAppUpdate = 'DevRejectAppUpdate',
    UAReleaseAppUpdate = 'ReleaseAppUpdate',
    UAUpdateReleasePilot = 'UpdateReleasePilot',
    UAAddRemoveEditCLI = 'AddRemoveEditCLI',
    UAPingCLI = 'PingCLI',
    UAToggleApprovalCLI = 'UAToggleApprovalCLI',
    UAToggleFRIgnore = 'ToggleFRIgnore',
    UAHaltRollout = 'HaltRollout',
    UAResumeRollout = 'ResumeRollout',
    UAUpdateRolloutPercentage = 'UpdateRolloutPercentage',
    UAAddRemoveEditReleaseBranchPatterns = 'AddRemoveEditReleaseBranchPatterns',
    UAAddRemoveEditReleaseTagPatterns = 'AddRemoveEditReleaseTagPatterns',
    UAAddRemoveEditFeatureAffiliations = 'AddRemoveEditFeatureAffiliations',
    UAAssignBetaTestersToBuilds = 'AssignBetaTestersToBuilds',
    UAAssignBetaGroupsToBuilds = 'AssignBetaGroupsToBuilds',
    UAUpdateAdditionalBranchConfig = 'UpdateAdditionalBranchConfig',
    UADownloadBuildArtifact = 'DownloadBuildArtifact',
    UARetryArtifactUpload = 'RetryArtifactUpload',
    UAUpdateMetadata = 'UpdateMetadata',
    UAEditReleasePlanningSummary = 'EditReleasePlanningSummary',
    UAEditReleaseSummaryMessage = 'EditReleaseSummaryMessage',
    UAEditAppStoreReleaseSettings = 'EditAppStoreReleaseSettings',
    UAApplyMetadata = 'ApplyMetadata',
    UASubmitBetaBuildForReview = 'SubmitBetaBuildForReview',
    UAPauseResumeScheduleCadence = 'PauseResumeScheduleCadence',
    UAUpdateBetaTestingNotes = 'UpdateBetaTestingNotes',
    UAAccessSSOPortal = 'AccessSSOPortal',
    UAAccessDirectorySyncPortal = 'AccessDirectorySyncPortal',
    UAInviteUsers = 'InviteUsers',
    UAEditUserGroups = 'EditUserRoles',
    UARemoveOrgUser = 'RemoveOrgUser',
    UABuildDistroOptIn = 'BuildDistroOptIn',
    UACreateBuildDistroBucket = 'CreateBuildDistroBucket',
    UABucketUpdateSettings = 'UpdateBucketSettings',
    UABucketUpdateNotifications = 'UpdateBucketNotifications',
    UABucketUpdateBucketMembers = 'UpdateBucketMembers',
    UABucketInviteIndividualTestersToBuilds = 'BucketInviteIndividualTestersToBuilds',
    UABucketUploadBuilds = 'BucketUploadBuilds',
    UABucketUpdateBuildTestersNotes = 'BucketUpdateBuildTesterNotes',
    UABucketInstallBuilds = 'BucketInstallBuilds',
    UAUpdateDirectorySyncUserGroupsForGroups = 'UpdateDirectorySyncRolesForGroups',
    UAStartRollbackResigningSequence = 'StartRollbackResigningSequence',
    UAAddRemoveDevice = 'AddRemoveDevice', // add user device
    UAAddRemoveDeviceFromApp = 'AddRemoveDeviceFromApp',
    UAUpdateDeviceInASC = 'UpdateDeviceInASC', // register, enable, disable
    UAUploadSigningKey = 'UploadSigningKey',
    UAImportExportTranslationStrings = 'ImportExportTranslationStrings',
    UAApproveTranslations = 'ApproveTranslations',
    UAAddFixRequest = 'AddFixRequest',
    UAUpdateFixRequestStatus = 'UpdateFixRequestStatus',
    UAUpdateAppStoreReviewSubmission = 'UpdateAppStoreReviewSubmission',
    UAUploadExportMetadataTranslations = 'UploadExportMetadataTranslations',
    UACreateEditDeleteCustomGroup = 'CreateEditDeleteCustomGroup',
    UAMarkReleaseAsRejected = 'MarkReleaseRejected',
    UACreateDeleteAPITokens = 'CreateDeleteAPITokens',
    UAAddUpdateRemoveWebhook = 'AddUpdateRemoveWebhook',
    UAAddRemoveTestDeviceFromApp = 'AddRemoveTestDeviceFromApp',
    UAAddRemoveUsersFromPilotRotation = 'AddRemoveUsersFromPilotRotation',
    UAAddRemoveEditRegressionItems = 'AddRemoveEditRegressionItems',
    UAUpdateRegressionItemsStatus = 'UpdateRegressionItemsStatus',
    UAAddRemoveEditApprovalItems = 'AddRemoveEditApprovalItems',
    UAUpdateApprovalItemsStatus = 'UpdateApprovalItemsStatus',
    UAUpdateOrgSettings = 'UpdateOrgSettings',
    UAIngestCustomOBAAMetrics = 'IngestCustomOBAAMetrics',
    UABucketArchiveBuilds = 'BucketArchiveBuilds',
    UAStartRollout = 'StartRollout',
    UAUpdatePhasedRelease = 'UpdatePhasedRelease',
    UACreateEditDeleteOrgTags = 'CreateEditDeleteOrgTags',
}

export const AllRunways = allCases(RunwayUserAction);

export enum RunwayUserActionCategory {
    UACAppManagement = 'AppManagement',
    UACApprovals = 'Approvals',
    UACBuildDistroSettings = 'BuildDistroSettings',
    UACChecklistItems = 'ChecklistItems',
    UACPublicAPIAndWebhooks = 'PublicAPIAndWebhooks',
    UACRegressionTesting = 'RegressionTesting',
    UACReleaseActions = 'ReleaseActions',
    UACReleaseSettings = 'ReleaseSettings',
    UACSSOSAMLManagement = 'SSOSAMLManagement',
    UACUserManagement = 'UserManagement',
    UACUserSettings = 'UserSettings',
}

export const getRunwayUserActionsForCategory = (category: RunwayUserActionCategory) => {
    switch (category) {
        case RunwayUserActionCategory.UACAppManagement:
            return [
                RunwayUserAction.UAAddRemoveEditIntegration,
                RunwayUserAction.UATriggerIntegrationRefresh,
                RunwayUserAction.UACreateDeleteApp,
                RunwayUserAction.UAUpdateAppSettings,
                RunwayUserAction.UAEditAutomations,
                RunwayUserAction.UAUpdateScheduleCadence,
                RunwayUserAction.UAAddRemoveUsersFromPilotRotation,
                RunwayUserAction.UAAddRemoveEditReleaseBranchPatterns,
                RunwayUserAction.UAAddRemoveEditReleaseTagPatterns,
                RunwayUserAction.UAAddRemoveEditFeatureAffiliations,
                RunwayUserAction.UAUpdateAdditionalBranchConfig,
                RunwayUserAction.UAAddRemoveDeviceFromApp,
                RunwayUserAction.UAUpdateDeviceInASC,
                RunwayUserAction.UAUploadSigningKey,
                RunwayUserAction.UAIngestCustomOBAAMetrics,
            ];
        case RunwayUserActionCategory.UACApprovals:
            return [RunwayUserAction.UAAddRemoveEditApprovalItems, RunwayUserAction.UAUpdateApprovalItemsStatus];
        case RunwayUserActionCategory.UACBuildDistroSettings:
            return [
                RunwayUserAction.UABuildDistroOptIn,
                RunwayUserAction.UACreateBuildDistroBucket,
                RunwayUserAction.UABucketArchiveBuilds,
            ];
        case RunwayUserActionCategory.UACChecklistItems:
            return [
                RunwayUserAction.UAAddRemoveEditCLI,
                RunwayUserAction.UAPingCLI,
                RunwayUserAction.UAToggleApprovalCLI,
            ];
        case RunwayUserActionCategory.UACPublicAPIAndWebhooks:
            return [RunwayUserAction.UACreateDeleteAPITokens, RunwayUserAction.UAAddUpdateRemoveWebhook];
        case RunwayUserActionCategory.UACRegressionTesting:
            return [
                RunwayUserAction.UAUpdateRegressionStatus,
                RunwayUserAction.UAAddRemoveEditRegressionItems,
                RunwayUserAction.UAUpdateRegressionItemsStatus,
            ];
        case RunwayUserActionCategory.UACReleaseActions:
            return [
                RunwayUserAction.UACreateSkipDeleteCompleteReleases,
                RunwayUserAction.UACreateHotfix,
                RunwayUserAction.UACreateBranchPromoteCode,
                RunwayUserAction.UAStartRollbackResigningSequence,
                RunwayUserAction.UABumpVersion,
                RunwayUserAction.UATagCommit,
                RunwayUserAction.UAApproveScreenshotsMetadata,
                RunwayUserAction.UAPromoteBetaBuildToTestingTrack,
                RunwayUserAction.UAApproveBetaTesting,
                RunwayUserAction.UASetResumeActiveRCBuild,
                RunwayUserAction.UATriggerCIWorkflow,
                RunwayUserAction.UAUpdateAppStoreSelectedBuild,
                RunwayUserAction.UASubmitAppUpdate,
                RunwayUserAction.UADevRejectAppUpdate,
                RunwayUserAction.UAMarkReleaseAsRejected,
                RunwayUserAction.UAReleaseAppUpdate,
                RunwayUserAction.UAToggleFRIgnore,
                RunwayUserAction.UAHaltRollout,
                RunwayUserAction.UAResumeRollout,
                RunwayUserAction.UAUpdateRolloutPercentage,
                RunwayUserAction.UAAssignBetaTestersToBuilds,
                RunwayUserAction.UAAssignBetaGroupsToBuilds,
                RunwayUserAction.UADownloadBuildArtifact,
                RunwayUserAction.UARetryArtifactUpload,
                RunwayUserAction.UAUpdateMetadata,
                RunwayUserAction.UAEditReleasePlanningSummary,
                RunwayUserAction.UAEditAppStoreReleaseSettings,
                RunwayUserAction.UAEditReleaseSummaryMessage,
                RunwayUserAction.UAApplyMetadata,
                RunwayUserAction.UASubmitBetaBuildForReview,
                RunwayUserAction.UAPauseResumeScheduleCadence,
                RunwayUserAction.UAUpdateBetaTestingNotes,
                RunwayUserAction.UAImportExportTranslationStrings,
                RunwayUserAction.UAApproveTranslations,
                RunwayUserAction.UAAddFixRequest,
                RunwayUserAction.UAUpdateFixRequestStatus,
                RunwayUserAction.UAUpdateAppStoreReviewSubmission,
                RunwayUserAction.UAUploadExportMetadataTranslations,
                RunwayUserAction.UAStartRollout,
            ];
        case RunwayUserActionCategory.UACReleaseSettings:
            return [RunwayUserAction.UAUpdateReleaseTargetDates, RunwayUserAction.UAUpdateReleasePilot];
        case RunwayUserActionCategory.UACSSOSAMLManagement:
            return [
                RunwayUserAction.UAAccessSSOPortal,
                RunwayUserAction.UAAccessDirectorySyncPortal,
                RunwayUserAction.UAUpdateDirectorySyncUserGroupsForGroups,
            ];
        case RunwayUserActionCategory.UACUserManagement:
            return [
                RunwayUserAction.UAEditUserGroups,
                RunwayUserAction.UARemoveOrgUser,
                RunwayUserAction.UAInviteUsers,
                RunwayUserAction.UACreateEditDeleteCustomGroup,
            ];
        case RunwayUserActionCategory.UACUserSettings:
            return [RunwayUserAction.UAAddRemoveDevice];
        default:
            return [];
    }
};
